import { GetNewslettersResponse } from '../types/types';

const extendNewslettersWithSubscribedField = (
  newslettersResponse: GetNewslettersResponse
): GetNewslettersResponse => ({
  ...newslettersResponse,
  data: newslettersResponse.data.map((newsletter) => ({
    ...newsletter,
    subscribed: false,
  }))
});

export { extendNewslettersWithSubscribedField };
